// 1. Atualizar o componente LoginFormWilder para receber as referências
import { useState } from "react";
import {
  Container,
  FormContent,
  FormField,
  Title,
  FormGroup,
  Label,
  Input,
  RetirementCard,
  CheckboxContainer,
  CheckboxLabel,
  Checkbox,
  ButtonContainer,
  BtnClose,
  BtnCancel,
  BtnRetire
} from './styles';

const LoginFormWilder = ({ onSubmit, onCancelar, onClose }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    pin: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Container>
      <FormContent>
        <BtnClose onClick={onClose}>✖</BtnClose>
        <Title>Atualizar contas</Title>

        <FormGroup>
          <FormField>
            <Label>Email:</Label>
            <Input
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </FormField>
          <FormField>
            <Label>Senha:</Label>
            <Input
              type="password"
              name="password"
              required
              value={formData.password}
              onChange={handleChange}
            />
          </FormField>
          <FormField>
            <Label>PIN:</Label>
            <Input
              type="text"
              name="pin"
              required
              value={formData.pin}
              onChange={handleChange}
            />
          </FormField>
          <ButtonContainer>

            <BtnCancel onClick={onClose}>
              Cancelar
            </BtnCancel>

            <BtnRetire
              primary
              type="button"
              onClick={handleSubmit}
            >
              Atualizar
            </BtnRetire>
          </ButtonContainer>
        </FormGroup>
      </FormContent>
    </Container>
  );
};

export default LoginFormWilder;